import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { Modal } from "rsuite";
import {
  Block,
  Description,
  Heading,
  Bold,
  Fieldset,
  Legend,
  Title,
} from "../styles/CommonStyles";
import { useNavigate } from "react-router-dom";

const combinedAnimation = keyframes`
  0% { 
    transform: translateX(0) rotate(0deg); 
  }
  10% { 
    transform: translateX(-5px) rotate(15deg); 
  }
  20% { 
    transform: translateX(5px) rotate(-15deg) scale(1.1); 
  }
  30% { 
    transform: translateX(-5px) rotate(10deg) scale(1.1); 
  }
  40% { 
    transform: translateX(5px) rotate(-10deg); 
  }
  50% { 
    transform: translateX(0) rotate(0deg); 
  }
  100% { 
    transform: translateX(0) rotate(0deg); 
  }
`;

const AnnouncementMessage = () => {
  const navigate = useNavigate();

  return <MailIcon onClick={(e) => navigate("/message")}></MailIcon>;
};

export default AnnouncementMessage;

const MailIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(to bottom, #ff9900, rgba(255, 153, 0, 0.5));
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  animation: ${combinedAnimation} 2s infinite;
  cursor: pointer;
  &::before {
    content: "✉️";
    font-size: 1rem;
    color: #fff;
  }

  /* Badge */
  &::after {
    display: flex;
    justify-content: center;
    align-items: center;
    content: "1";
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: #fff;
    color: #ff9900;
    border-radius: 50%;
    padding: 3px 6px;
    font-size: 0.6rem;
    width: 15px;
    height: 15px;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    &::before {
      font-size: 2rem; /* Keep font size at 1rem on mobile */
    }
    &::after {
      width: 15px;
      height: 15px;
      font-size: 1rem; /* Adjust font size for badge */
      top: 0.2rem; /* Adjust top position */
      right: 0.2rem; /* Adjust right position */
    }
  }
`;
